<template>
  <div class="home" id="home-index">
    <!-- <div class="notice-box">
      <notice />
    </div> -->

    <!-- <div class="xzqh-box">
      <change-xzqh
        :default-county="county"
        @callBackRegion="callBackRegion"
        @changeType="changeType"
      />
    </div> -->
    <div class="land-map-box">
      <div class="land-map-left">
        <!-- 消息通知 -->
        <div class="land-notice">
          <notice />
        </div>
        <!-- 地图echarts -->
        <map-box
          class="land-map-map"
          @callBackCounty="callBackCounty"
          @changeCounty="changeCounty"
        ></map-box>
      </div>
      <div class="land-map-right">
        <!-- 市县介绍 -->
        <boast :xzqh="xzqh" class="boast-box" />
        <!-- 地块统计 -->
        <div class="census-box">
          <census :county="xzqh" @callBackXzqh="callBackXzqh" />
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <!-- 园区 -->
      <div class="park">
        <park2 :county="xzqh"></park2>
      </div>
      <!-- 热门地块 -->
      <land2 class="land-map-land" :county="xzqh" :recommended="recommended" />
      <!-- <div class="industry">
        <industry2></industry2>
      </div> -->
    </div>
    <div class="bottom-box1">
      <Project :county="xzqh"></Project>
    </div>
    <div class="bottom-box2">
      <Promote></Promote>
    </div>
    <tools></tools>
    <!--左侧的轮播呀-->
    <div
      id="left-carousel-box"
      :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }"
    >
      <div class="left-carousel1">
        <img
          class="video-box"
          src="https://www.landyunnan.cn/zxd/file-yn-cms/file/video/xcp/fm.png"
          alt=""
        />
        <div
          class="video-icon el-icon-video-play"
          @click="visible = true"
        ></div>
        <!-- <div class="video-title">七彩云南 投资沃土</div> -->
      </div>
      <div class="left-carousel2">
        <img
          class="video-box"
          src="https://www.landyunnan.cn/zxd/file-yn-cms/file/video/cz/fm.png"
          alt=""
        />
        <div
          class="video-icon el-icon-video-play"
          @click="visible1 = true"
        ></div>
        <!-- <div class="video-title">七彩云南 投资沃土</div> -->
      </div>
      <div class="left-carousel">
        <el-carousel height="140px">
          <el-carousel-item v-for="(item, index) in fiveData" :key="index">
            <!-- :style="{
              background: `url(${imageAddress(fiveData[0])})`,
              backgroundSize: `100% 100%`,
            }" -->
            <div class="carousel-img" @click="openCentralYunnan(item)">
              <img
                :src="imageAddress(fiveData[index])"
                alt=""
                style="width: 100%; height: 100%"
              />
              <div class="carousel-img-span">{{ item.name }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- <div class="left-carousel2">
        <img src="@/assets/images/touchulogo.png" alt=""
        @click="handleJump()"
        >
    </div> -->
    </div>
    <el-dialog
      class="dialog-box"
      width="90%"
      top="50px"
      :visible.sync="visible"
    >
      <video
        class="video-dialog"
        src="https://www.landyunnan.cn/zxd/file-yn-cms/file/video/xcp/qcynzxd.mov"
        controls
      ></video>
    </el-dialog>
    <el-dialog
      class="dialog-box"
      width="90%"
      top="50px"
      :visible.sync="visible1"
    >
      <video
        class="video-dialog"
        src="https://www.landyunnan.cn/zxd/file-yn-cms/file/video/cz/czsp.m4v"
        controls
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import Land2 from "@/views/home/components/land2";
import notice from "@/views/home/components/notice";
import Boast from "@/views/home/components/boast";
import MapBox from "@/views/home/components/mapBox";
import census from "@/views/home/components/census";
import Park2 from "@/views/home/components/park2";
import Industry2 from "@/views/home/components/industry2";
import ChangeXzqh from "@/views/home/components/changeXzqh";
import Tools from "@/views/home/components/tools";
import Project from "@/views/home/components/project";
import Promote from "@/views/home/components/promote";
import img01 from "@/assets/newImg/img03.png";
import img02 from "@/assets/newImg/img04.png";
import img03 from "@/assets/newImg/img05.png";
import { promotionFive } from "@/api/common";
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/12 17:54
 * @Description 首页
 */
export default {
  name: "home",
  components: {
    Boast,
    Land2,
    notice,
    census,
    ChangeXzqh,
    MapBox,
    Park2,
    Industry2,
    Tools,
    Project,
    Promote,
  },
  data() {
    return {
      screenIndexWidth: null,
      visible: false,
      visible1: false,
      county: [],
      xzqh: "53",
      recommended: "",
      countyList: [{ value: "53", label: "云南省", is_check: true }],
      introductionImg: [
        { name: "2023滇中土地推介专场", url: img01 },
        { name: "2023滇中土地推介专场", url: img02 },
        { name: "2023滇中土地推介专场", url: img03 },
      ],
      fiveData: [],
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
    };
  },
  beforeRouteUpdate(to, from, next) {},
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度

    this.getData();
  },
  methods: {
    // 返回图片地址
    imageAddress(val) {
      if (!!val) {
        if (!!val.file && val.file.length > 0) {
          return `${this.imgUrl}${val.file[0].filePath}`;
        }
      }
    },
    // 获取土地推介专场
    getData() {
      promotionFive().then((res) => {
        if (res.data.success) {
          this.fiveData = res.data.data.data;
        }
      });
    },
    handleJump() {
      window.open("https://invest.yn.gov.cn/");
    },
    // 跳转新窗口
    // openCentralYunnan() {
    //   let id = this.id;
    //   const { href } = this.$router.resolve({
    //     name: `centralYunnan`,
    //     params: {
    //       id: id,
    //     },
    //   });
    //   window.open(href, "_blank");
    // },
    // 跳转新窗口
    openCentralYunnan(item) {
      let name = item.templateId == 0 ? "centralYunnan" : "formWorkOne";

      if (!!item) {
        this.editId = item.id;
        const { href } = this.$router.resolve({
          name: name,
          query: {
            id: this.editId,
          },
        });
        window.open(href, "_blank");
      }
    },
    //地图点击返回行政区划代码
    callBackCounty(val) {
      this.xzqh = val;
      // this.$emit("callBackXzqh", val);
    },
    //返回行政区划数组
    changeCounty(val) {
      this.countyList = val;
    },
    callBackRegion(val) {
      this.xzqh = val[val.length - 1];
    },
    changeType(val) {
      this.recommended = val;
    },
    callBackXzqh(val) {
      if (val.length == 2) {
        this.county = ["53"];
        this.xzqh = val;
      }
      if (val.length == 4) {
        let str = val.slice(0, 4);
        this.county = ["53", str];
        this.xzqh = str;
      }
      if (val.length == 6) {
        let str1 = val.slice(0, 4);
        let str2 = val.slice(0, 6);
        this.county = ["53", str1, str2];
        this.xzqh = str2;
      }
    },
  },
};
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 20%;
  width: 60%;
  background: #fff;
  position: relative;
}
.notice-box {
  margin-top: 20px;
  width: 100%;
  /* width: 60%; */
}
.xzqh-box {
  margin: 80px auto 9px;
  width: 100%;
}

.boast-box {
  width: 100%;
  /* margin: 100px 0; */
}
.land-map-box {
  height: 800px;
  width: 100%;
  display: flex;
  margin-top: 20px;
}
.land-map-land {
  /* height: calc(100% - 395px);
  margin-top: 20px; */
  width: calc(65% - 20px);
}
.land-notice {
  height: 19px;
  width: calc(100% - 10px);
  margin-left: 10px;
}
.land-map-left {
  width: 55%;
  height: 100%;
}
.land-map-map {
  height: calc(100% - 19px);
}
.land-map-right {
  width: calc(45% - 20px);
  margin: 0 10px;
}
.bottom-box {
  margin-top: 30px;
  display: flex;
  width: 100%;
  height: 500px;
  padding: 10px 0 20px;
}
.bottom-box1 {
  display: flex;
  width: 100%;
  height: 440px;
  padding: 10px 0 20px;
}
.park {
  width: calc(35% - 20px);
  height: 100%;
  margin-right: 20px;
}
.industry {
  width: calc(35% - 20px);
  height: 100%;
  margin-right: 20px;
}
.census-box {
  width: 100%;
}
.left-carousel {
  background: #ffffff;
  width: 240px;
  position: absolute;
  left: -323px;
  top: 458px;
  border-radius: 4px;
  padding: 10px;
  z-index: 99;
}
.left-carousel1 {
  background: #ffffff;
  width: 240px;
  position: absolute;
  left: -323px;
  top: 78px;
  border-radius: 4px;
  padding: 10px;
  z-index: 99;
}

.left-carousel2 {
  height: 140px;
  background: #ffffff;
  width: 240px;
  position: absolute;
  left: -323px;
  top: 270px;
  border-radius: 4px;
  padding: 10px;
  z-index: 99;
}
.left-carousel2 img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.video-box {
  width: 240px;
  height: 140px;
}
.video-dialog {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.dialog-box {
  z-index: 99999;
  height: 100%;
}
::v-deep .dialog-box .el-dialog__body {
  width: calc(100% - 40px);
  height: calc(100% - 90px);
}
::v-deep .dialog-box > .el-dialog {
  height: calc(100% - 100px);
}
.video-title {
  position: absolute;
  bottom: 25px;
  color: #fff;
  font-size: 1rem;
  padding: 1px 0;
  width: calc(100% - 20px);
  text-align: center;
  /* background: #ffffff42; */
}
.video-icon {
  position: absolute;
  top: calc((100% - 44px) / 2);
  left: calc((100% - 44px) / 2);
  display: flex;
  align-items: center;
  color: #fff;
  z-index: 2;
  font-size: 2.25rem;
  cursor: pointer;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 0.85rem;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
/deep/ .el-carousel--horizontal {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.left-carousel-img {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.left-carousel-img-item {
  background: #e5e5e5;
  width: 100%;
  height: 140px;
  font-size: 0.85rem;
  color: #ffffff;
  display: flex;
  align-items: end;
  justify-content: center;
  padding-bottom: 10px;
  box-sizing: border-box;
}
.left-carousel-img-item1 {
  background: url("~@/assets/newImg/img01.png") no-repeat;
  background-size: 100% 100%;
}
.left-carousel-img-item2 {
  background: url("~@/assets/newImg/img02.png") no-repeat;
  background-size: 100% 100%;
}
.left-carousel-img-item:nth-child(2) {
  margin-left: 10px;
}
.carousel-img {
  box-sizing: border-box;
  height: 100%;
  color: #ffffff;
  cursor: pointer;
  position: relative;
}
.carousel-img-span {
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: center;
  bottom: 20px;
  z-index: 2;
  position: absolute;
}
/deep/ .el-carousel__button {
  width: 10px;
}
.bottom-box2 {
  display: flex;
  width: 100%;
  height: 25px;
  align-items: center;
  padding: 10px 0 20px;
  /* background: red; */
}
</style>
